import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../hooks/useCart';
import './Header.css';

function Header() {
  const { getCartCount } = useCart();
  const navigate = useNavigate();
  const cartCount = getCartCount();
  const [user, setUser] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const checkUser = () => {
      const userData = localStorage.getItem('user');
      if (userData) {
        setUser(JSON.parse(userData));
      } else {
        setUser(null);
      }
    };

    checkUser();

    // Listen for storage changes (when logging out from another component)
    window.addEventListener('storage', checkUser);

    // Custom events for same-window login/logout
    window.addEventListener('login', checkUser);
    window.addEventListener('logout', checkUser);

    return () => {
      window.removeEventListener('storage', checkUser);
      window.removeEventListener('login', checkUser);
      window.removeEventListener('logout', checkUser);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('user');
    setUser(null);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event('logout'));
    navigate('/');
  };

  const getUserLink = () => {
    if (!user) {
      return '/login';
    }
    return user.role === 'admin' ? '/admin/dashboard' : '/account';
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <button
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <i className={mobileMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </button>

        <Link to="/" className="logo">
          <img src="/images/wtf_wear-1.png" title="wtf_wear" alt="wtf_wear" loading="lazy" className="logo-img" />
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
          <Link to="/shop" className="nav-link" onClick={closeMobileMenu}>Shop</Link>
          <Link to="/about" className="nav-link" onClick={closeMobileMenu}>About</Link>
          <Link to="/faq" className="nav-link" onClick={closeMobileMenu}>FA-Q</Link>
          <Link to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact</Link>
          <Link to="/cart" className="nav-link" onClick={closeMobileMenu}>Cart</Link>
        </nav>

        <div className={`mobile-overlay ${mobileMenuOpen ? 'show' : ''}`} onClick={closeMobileMenu}></div>

        <div className="header-icons">
          {user ? (
            <div className="user-menu">
              <Link to={getUserLink()} className="icon-button" aria-label="User account">
                <i className="fas fa-user"></i>
                <span className="user-name">{user.name || user.email}</span>
              </Link>
              <button onClick={handleLogout} className="logout-button" aria-label="Logout">
                <i className="fas fa-sign-out-alt"></i>
              </button>
            </div>
          ) : (
            <Link to="/login" className="icon-button" aria-label="Login">
              <i className="fas fa-user"></i>
            </Link>
          )}

          <Link to="/cart" className="icon-button cart-icon-link">
            <i className="fas fa-shopping-cart"></i>
            {cartCount > 0 && (
              <span className="cart-count-badge">{cartCount}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
